import { canAccessRole, UserRoleEnum } from '@entities/User';
import { AGENT_TAB_KEYS, isAgentTab } from '@pages/AgentDashboard';
import { createFileRoute, redirect } from '@tanstack/react-router';

import { AgentDashboardRoutePage } from './-AgentDashboardRoutePage';

interface AgentSearch {
  tab: (typeof AGENT_TAB_KEYS)[number];
}

export const Route = createFileRoute('/_app/__auth/agent/')({
  beforeLoad: ({ context }) => {
    const role = context.auth.user?.role;

    if (
      context.auth.user &&
      !canAccessRole(role, [UserRoleEnum.Agent, UserRoleEnum.Admin])
    ) {
      throw redirect({ to: '/' });
    }
  },
  component: AgentDashboardRoutePage,
  validateSearch: (search: Record<string, unknown>): AgentSearch => {
    const tab = typeof search.tab === 'string' ? search.tab : AGENT_TAB_KEYS[0];

    return {
      tab: isAgentTab(tab) ? tab : AGENT_TAB_KEYS[0],
    };
  },
});
